import { useSetSelectedServiceValueFormState } from '@/atoms/form/selected-service-value-form-state';
import Button from '../Button';
import { useSetOpenedPopupsState } from '@/atoms/opened-popups';
import { FEEDBACK_POPUP_NAME } from '@/components/general/FeedbackPopup/FeedbackPopup';
import ServiceCardCanvas from './ServiceCardCanvas';
import { useState } from 'react';
import { useMediaQueryDeviceState } from '@/atoms/media-query-device';
import {
    FeedbackPopupDataName,
    useSetFeedbackPopupDataNameState,
} from '@/components/general/FeedbackPopup/use-feedback-popup-data-name-atom';
import { useMediaQuery } from 'usehooks-ts';
import classNames from 'classnames';

interface Props {
    title: string;
    description: string;
    isActive?: boolean;
    feedbackPopupDataName?: FeedbackPopupDataName;
}

const ServiceCard = ({ title, description, isActive = false, feedbackPopupDataName = 'empty' }: Props) => {
    const setServiceValueFormState = useSetSelectedServiceValueFormState();
    const { openPopup } = useSetOpenedPopupsState();
    const [isHovered, setIsHovered] = useState(false);
    const [device] = useMediaQueryDeviceState();
    const isLargeTabletHorizontal = useMediaQuery('(max-width: 1366px) and (pointer: coarse)');
    const isPlaying = device === 'desktop' ? isHovered : isActive;
    const setFeedbackPopupDataName = useSetFeedbackPopupDataNameState();

    return (
        <div
            className={classNames('service-card', { 'service-card--animated': isLargeTabletHorizontal })}
            onMouseEnter={() => {
                setIsHovered(true);
            }}
            onMouseLeave={() => {
                setIsHovered(false);
            }}
        >
            <span className="service-card__top">
                <span className="service-card__title h2">{title}</span>
                <span className="serivce-card__description text-l">{description}</span>
            </span>
            <Button
                geometryVariant="mustache"
                tag="span"
                onClick={() => {
                    setServiceValueFormState(title);
                    setFeedbackPopupDataName(feedbackPopupDataName);
                    openPopup(FEEDBACK_POPUP_NAME);
                }}
            >
                Подать заявку
            </Button>
            <ServiceCardCanvas isPlaying={isPlaying || isActive} />
        </div>
    );
};

export default ServiceCard;
